import api from "../../../config/gatewayConfig";
import { httpClient, silentPollingConfig } from "../../httpClient";
import { buildAttachmentFields } from "../../ticketAttachmentUtils";

export const apiTicketProvider = {
  createTicket: async ({ title, description, file }) => {
    const attachment = await buildAttachmentFields(file);
    return httpClient.post(api.vendorTicketNew, {
      subject: title.trim(),
      description: description.trim(),
      ...attachment,
    });
  },

  listTickets: async (payload) => {
    return httpClient.post(api.vendorTicketList, payload ?? {}, {
      headers: { "Content-Type": "application/json" },
    });
  },

  sendMessage: async ({ ticketId, message, file }) => {
    const attachment = await buildAttachmentFields(file);
    return httpClient.post(api.vendorTicketMessage, {
      ticketId,
      message: message?.trim() || undefined,
      ...attachment,
    });
  },

  listMessages: async (payload) => {
    return httpClient.post(api.vendorTicketMessageList, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  downloadAttachment: async (payload) => {
    return httpClient.post(api.vendorTicketMessageAttachment, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  editMessage: async ({ file, existingAttachmentKept, ...payload }) => {
    const attachment = await buildAttachmentFields(file);
    return httpClient.post(api.vendorTicketMessageEdit, {
      ticketId: payload.ticketId,
      messageId: payload.messageId,
      action: payload.action,
      message: payload.message?.trim() || undefined,
      removeAttachment: payload.removeAttachment || undefined,
      ...attachment,
    });
  },

  getSummary: async ({ silent = false } = {}) => {
    return httpClient.post(api.vendorTicketSummary, {}, {
      headers: { "Content-Type": "application/json" },
      ...(silent ? silentPollingConfig : {}),
    });
  },

  pollMessages: async (payload, { silent = false } = {}) => {
    return httpClient.post(api.vendorTicketMessagePoll, payload, {
      headers: { "Content-Type": "application/json" },
      ...(silent ? silentPollingConfig : {}),
    });
  },
};
